/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationsNotFoundError
 */
export interface NotificationsNotFoundError {
    /**
     * 
     * @type {number}
     * @memberof NotificationsNotFoundError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationsNotFoundError
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsNotFoundError
     */
    message: string;
}

/**
 * Check if a given object implements the NotificationsNotFoundError interface.
 */
export function instanceOfNotificationsNotFoundError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function NotificationsNotFoundErrorFromJSON(json: any): NotificationsNotFoundError {
    return NotificationsNotFoundErrorFromJSONTyped(json, false);
}

export function NotificationsNotFoundErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsNotFoundError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': json['message'],
    };
}

export function NotificationsNotFoundErrorToJSON(value?: NotificationsNotFoundError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': value.message,
    };
}

